import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("slideShow2", component(opts));
  editor.BlockManager.add("slideShow2", block(opts));
};